//TODO: replace with swiper js
import Glide from '@glidejs/glide';

const DEVICE = window.matchMedia('(max-width: 999px)').matches ? 'mobile' : 'desktop';

class Sliders {
  constructor() {
    if( document.querySelector('.gallery-slider-glide') ){
      this.galleryGlide();
    }
    if( document.querySelector('.offer-slider-glide') ){
      this.offerGlide();
    }
    if( document.querySelector('.custom-block-slider-gallery-glide') ){
      this.blockGalleryGlide();
    }
    if( document.querySelector('.home-glider') ){
      this.homeGlide();
    }
  }

  homeGlide() {
    new Glide('.home-glider', {
      autoplay: 5000,
      gap:0
    }).mount();
  }

  offerGlide() {
    let el = document.querySelector('.offer-slider-glide');
    let length = parseInt( el.getAttribute('data-desktop-items') );
    if( DEVICE == 'desktop' ){
      new Glide('.offer-slider-glide', {
        type: length <= 5 ? 'slider': 'carousel',
        startAt: 0,
        focusAt: 0,
        dragThreshold: length <= 5 ? false: true,
        perView: DEVICE == 'desktop' ? length : 1,
        gap: DEVICE == 'desktop' ? 40 : 10
      }).mount()
    }else{
      new Glide('.offer-slider-glide', {
        type: 'carousel',
        startAt: 0,
        focusAt: 'center',
        perView: DEVICE == 'desktop' ? length : 1,
        gap: DEVICE == 'desktop' ? 40 : 10
      }).mount()
    }

  }

  galleryGlide() {

    new Glide('.gallery-slider-glide', {
      type: 'carousel',
      startAt: 0,
      focusAt: 0,
      perView: DEVICE == 'desktop' ? 3 : 1,
      gap: DEVICE == 'desktop' ? 40 : 10
    }).mount()
  }

  blockGalleryGlide() {
    new Glide('.custom-block-slider-gallery-glide', {
      type: 'carousel',
      startAt: 0,
      focusAt: 0,
      perView: 1,
      gap: DEVICE == 'desktop' ? 40 : 10
    }).mount()
  }
}

export default Sliders;
